// extracted by mini-css-extract-plugin
export var caption = "focusable-iframe-module--caption--wOUL6";
export var container = "focusable-iframe-module--container--oiR2+";
export var iframeContainer = "focusable-iframe-module--iframeContainer--KcRuy";